export enum Denominator {
  None = '',
  Thousands = 'k',
  Millions = 'm',
  Billions = 'b',
  Trillions = 't',
  Percentage = '%',
}

export const getSuffix: (den: Denominator) => string = (den) => {
  return den.valueOf();
};

export const getValue: (den: Denominator) => number = (den) => {
  switch (den) {
    case Denominator.Thousands:
      return 1000;
    case Denominator.Millions:
      return 1000000;
    case Denominator.Billions:
      return 1000000000;
    case Denominator.Trillions:
      return 1000000000000;
    case Denominator.None:
    default:
      return 1;
  }
};
